if(document.querySelectorAll('.productcat-carousel__container').length) {
  try {
    var swiper = new Swiper('.productcat-carousel__container', {
      slidesPerView: 1,
      spaceBetween: 0,
      slidesPerGroup: 1,
      direction: 'horizontal',

      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 32,
          slidesPerGroup: 2,
        },

        1024: {
          slidesPerView: 3,
          spaceBetween: 32,
          slidesPerGroup: 3,
        },
      },

      pagination: {
        el: ".cat-pagination",
        type: "fraction",
      },
      navigation: {
        nextEl: ".cat-next",
        prevEl: ".cat-prev",
      },
    });
  } catch (e) {
    console.log(e);
  }
}